import React from 'react';
import { motion } from 'framer-motion';

const Navbar = () => {
  return (
    <motion.nav 
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
      className="fixed w-full z-50 bg-white shadow-md border-b border-gray-200 h-16 flex items-center"
    >
      <div className="w-full px-4 lg:px-8 flex justify-center items-center relative">
        <div className="absolute left-4 lg:left-8 flex-shrink-0">
          <div className="rounded py-1">
            <img 
              alt="Brand Logo" 
              className="h-10 w-auto object-contain" 
              src="https://storage.googleapis.com/msgsndr/Te8QGpu12zbMxZIVQlZi/media/697b5f0d1f68d175d6f73cbe.png"
            />
          </div>
        </div>

        <div className="flex flex-col items-center text-center">
          <h1 className="text-black font-extrabold text-lg md:text-2xl leading-none tracking-tight">
            Yinguru Academy
          </h1>
          <p className="text-red-600 text-[8px] md:text-[10px] font-bold tracking-[0.2em] uppercase mt-0.5">
            UNLEASH THE POWER OF UNSEEN
          </p>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;